export const RECENT_SEARCH_STORAGE_KEY = 'recentSearch'